export const locale = {
  lang: 'tr',
  data: {
    'NOTIFICACIONES': {
      'INFO': {
        'HOY': 'Bugün',
        'TITUNOT': 'Bildirimler',
        'NOTTTIP': 'Okundu olarak işaretle'
      },
      'EDITOR_EMAILS': {
        'NUEVAMOD': '<b>-ALVPRRO-</b> şirketi, bir veya daha fazla iletişim e-postasında bir değişiklik yaptı',
        'NUEVAMODODS': 'Bir proje yöneticisi <b>-ALVPRRO-</b> şirketi için bir veya daha fazla iletişim e-postasında değişiklik yaptı'
      },
      'AUTORI-ENCUESTA': {
        'AUTORIZAR-ENCUESTA': '<b>-ALVPRRO-</b> şirketi anketi yetkilendirmek için gönderdi',
      },
    },
    'NOTIFICACION_PRODUCT':{
      'PRODUCTOS_ID':{
        '20':'Sertifikası',
        '40':'3,0 Sertifikası',
        '41':'Ölçü 3.0',
        '42':'Pulsecheck 3.0',
        '43':'Odak Alanı',
        '56': 'AMCO',
        '57': 'İnsana Yakışır İş',
        '58':'İlk İş',
        '63':'NOM-035 v3.0',
      },
      'TIPO_MENSAJE_MOSTRAR':{
        'languageNative':'Ana dili seçtiniz',
        'sinAdicionales':'Başka dil seçmediniz',
        'languageAdittional':'Ek dilleri seçtiniz',
        'conAditional':'Ek diller olmadan kontrolün seçimini kaldırdınız',
        'deleteLangNative':'Ana dili sildiniz',
        'completePasLang':'Dil adımını tamamladınız',
        'completePasTemplate':'Şablon adımını tamamladınız',
        'completePasReacti': 'Reaktif adımını tamamladınız',
        'completePasNps': 'nps adımını tamamladınız',
        'completePasControl': 'Kontrol adımını tamamladınız',
        'completePasDemogra': 'Demografik bilgi adımını tamamladınız',
        'completePasAbierta': 'Açma adımını tamamladınız',
        'completePasAdicio': 'Ek adımı tamamladınız',
        'completePas4all': 'Forall adımını tamamladınız',
        'completePasEncues': 'Anket adımını tamamladınız',
        'completePasColab': 'Ortak çalışanlar adımını tamamladınız',
        'completePasEnvi': 'Gönderme adımını tamamladınız',
        'completePasEstat': 'Anket durumu adımını tamamladınız',
        'completePasProgra': 'Programlama adımını tamamladınız',
        'DescompletePasLang': 'Dil adımını tamamladınız',
        'DescompletePasTemplate': 'Şablon adımını tamamladınız',
        'DescompletePasReacti': 'Reaktif adımını tamamlamadınız',
        'DescompletePasNps': 'nps adımını tamamladınız',
        'DescompletePasControl': 'Kontrol adımını tamamladınız',
        'DescompletePasDemogra': 'Demografik bilgi adımını tamamlamadınız',
        'DescompletePasAbierta': 'Açık adımı tamamlamadınız',
        'DescompletePasAdicio': 'Ek adımı tamamlamadınız',
        'DescompletePas4all': 'Forall adımını tamamlamadınız',
        'DescompletePasEncues': 'Anket adımını tamamlamadınız',
        'DescompletePasColab': 'Ortak çalışanlar adımını tamamlamadınız',
        'DescompletePasEnvi': 'Gönderme adımını tamamlamadınız',
        'DescompletePasEstat': 'Anket durumu adımını tamamlamadınız',
        'DescompletePasProgra': 'Programlama adımını tamamlamadınız',
        'createSurvey': 'Anket oluşturuldu',
        'saveUserDemo': 'Demo kullanıcılarını ankete kaydettiniz',
        'recreateSurvey': 'Anket yeniden oluşturuldu',
        'saveSeccionNps': 'nps bölümü ankete kaydedildi',
        'saveSeccionReactivos': 'Reaktifler bölümü ankete kaydedildi',
        'saveSeccionControl': 'Kontrol bölümü ankete kaydedildi',
        'saveSeccionDemogra': 'Demografik bölüm ankete kaydedildi',
        'saveSeccionAbier': 'Açık bölüm ankete kaydedildi',
        'saveSeccionForall': 'Forall bölümü ankete kaydedildi',
        'saveSeccionAdicio': 'Ek bölüm ankete kaydedildi',
        'subBaseColab': 'Katkıda bulunan tabanı yüklendi',
        'downloadBaseColab': 'Katkıda bulunan tabanı indirildi',
        'deleteBaseColab': 'Katkıda bulunan tabanı silindi',
        'saveUsersSurvey': 'Anket ortak çalışanları kaydedildi',
        'regisFechaLanza': 'Anketin başlama tarihi kaydedildi',
        'regisFechaAviso1': 'Anketten önceki 1 bildirim tarihi kaydedildi',
        'regisFechaAviso2': 'Anketten önceki 2 uyarı tarihi kaydedildi',
        'saveRecordatorioEncu': 'Bir hatırlatıcı kaydedildi',
        'enviarCorreos': 'İşbirlikçilerinize posta göndermeyi seçtiniz',
        'noEnviarCorreos': 'Postayı ortak çalışanlarınıza göndermemeyi seçtiniz',
        'cambiarEstatusCorreo': 'Posta gönderimini değiştirmek için değişiklik yaptınız',
        'ActivaEstatEncu': 'Anket etkinleştirildi',
        'DesacEstatEncu': 'Anket devre dışı bırakıldı',
        'activoSeccionNps':'NPS bölümü anket için etkinleştirildi',
        'desActivoSeccionNps':'NPS bölümü anket için devre dışı bırakıldı',
        'activoSeccionReactivos':'REAKTİF bölümü anket için etkinleştirildi',
        'desActivoSeccionReactivos':'REACTIVOS bölümü anket için devre dışı bırakıldı',
        'activoSeccionControl':'KONTROL bölümü anket için etkinleştirildi',
        'desActivoSeccionControl':'KONTROL bölümü anket için devre dışı bırakıldı',
        'activoSeccionDemograficos':'DEMOGRAFİK bölümü anket için etkinleştirildi',
        'desActivoSeccionDemograficos':'DEMOGRAFİK bölümü anket için devre dışı bırakıldı',
        'activoSeccionAbiertas':'AÇIK bölümü anket için etkinleştirildi',
        'desActivoSeccionAbiertas':'ABIERTAS para la encuesta bölümü devre dışı bırakıldı',
        'activoSeccionForall':'Forall bölümü anket için etkinleştirildi',
        'desActivoSeccionForall':'Forall bölümü anket için devre dışı bırakıldı',
        'activoSeccionAdicionales':'Anket için EK bölümü etkinleştirildi',
        'desActivoSeccionAdicionales':'EK bölümü anket için devre dışı bırakıldı',
        'deletePregTemNps':'Soru NPS bölümünden silindi',
         'deletePregTemReacti':'Soru, REAKTİFLER bölümünden silinmiştir',
         'deletePregTemControl':'Soru KONTROL bölümünden silindi',
         'deletePregTemDemogra':'Soru DEMOGRAFİK bölümünden silindi',
         'deletePregTemAbier':'Soru AÇ bölümünden silindi',
         'deletePregTemAdici':'Soru EK bölümünden silinmiştir',
         'savePregCatNps':'Katalog sorusu NPS bölümüne kaydedildi',
         'savePregCatReacti':'Katalog sorusu REAKTİFLER bölümüne kaydedildi',
         'savePregCatControl':'Katalog sorusu KONTROL bölümüne kaydedildi',
         'savePregCatDemogra':'Katalog sorusu DEMOGRAFİK bölümüne kaydedildi',
         'savePregCatAbier':'Katalog sorusu AÇIK bölümüne kaydedildi',
         'savePregCatAdici':'Katalog sorusu EKLER bölümüne kaydedildi',
         'savePregNueNps':'Yeni soru NPS bölümüne kaydedildi',
         'savePregNueReacti':'Yeni soru REAKTİFLER bölümüne kaydedildi',
         'savePregNueControl':'Yeni soru KONTROL bölümüne kaydedildi',
         'savePregNueDemogra':'Yeni soru DEMOGRAFİK bölümüne kaydedildi',
         'savePregNueAbier':'Yeni soru AÇ bölümüne kaydedildi',
         'savePregNueAdici':'Yeni soru EKLER bölümüne kaydedildi',
         'editPregNps':'Soru NPS bölümünde düzenlendi',
         'editPregReacti':'REAKTİFLER bölümündeki soru düzenlendi',
         'editPregControl':'KONTROL bölümündeki soru düzenlendi',
         'editPregDemogra':'DEMOGRAPHICS bölümündeki soru düzenlendi',
         'editPregAbier':'AÇIK bölümündeki soru düzenlendi',
         'editPregAdici':'EK bölümündeki soru düzenlendi',
         'LogOut':'Çıkış yaptınız',
         'reiniciarLang':'Ürünü yeniden başlattınız',
         'accionText':'',
         'updatCuesForall':'The questionnaire of the forall section has been updated.',
         'savePracticaForall':'Antrenman forall kaydedildi',
         'saveDescripForall':'Uygulama forallının açıklaması kaydedildi.',

      },
      'BTN_MOSTRAR_HISTO':'Geçmişi göster',
      'ETI_PRODUC':'Ürün:',
      'TITLE_HISTO_PROD':'Ürün geçmişi',
      'CARG_INFOR':'Bilgi yükleniyor',
      'TITLE_FILTER':'Filtre: ',
      'DELETE_FILTER':'Filtreleri sil',
      'FILTER_1':'Tarih:',
      'BUSCAR_FILTER':'Ara',
      'TH_TITTLE':'Ürün Geçmişi',
      'BTN_FILTER_HISTO':'Filtre Geçmişi',
      'TD_USUARIO':'Kullanıcı:',
      'TD_PRODU_FECHA_PRODU':'Ürün tarihi:',
      'TD_TIPO_PRODU':'Ürün tipi:',
      'TD_TIPO_USU_ADMI':'Yönetici kullanıcı',
      'WARNING_NO_DATOS':'Görüntülenecek bilgi yok',

    }
  }
};
